<template>
    <div class="home">


        <div class="creppy-white-blass-wait">
            <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-white">Partner</h5>

            <br class="no-move"/>

        </div>

        <div class="main-title">

            <br class="no-move"/>
            <br class="no-move"/>
            <br class="no-move"/>


     <!--      <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-dark">Keine Partner</h5> -->

            <b-img src="../assets/spieleoase.png" class="img no-move"></b-img>
            <br class="no-move"/>
            <br class="no-move"/>
            <a href="https://spieleoase.net" target="_blank" class="footnote-text text-dark ">Spieleoase</a>

            <br class="no-move"/>
            <br class="no-move"/>
            <br class="no-move"/>

            <div class="container">

                <h1 class="headers-text text-dark"><strong>Weitere Möglichkeiten</strong></h1>
                <p class="body-title-lighter text-dark"><strong>Mit "/lhpartner" hast du weitere Möglichkeiten die Partner Netztwerke zu entdecken.</strong></p>

            </div>

            <br class="no-move"/>

            <div class="" style="alignment: bottom">

                <div class="" style="alignment: bottom">
                    <p class="smaller-end-text">© {{today.getFullYear()}}
                        <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/apply">Apply</a>
                        -
                        <a style="color: #6868b3"
                           href="ts3server://labyhelp.de">TeamSpeak</a>
                        -
                        <a style="color: #6868b3"
                           href="https://discord.gg/eX6g3zD">Discord</a>
                    </p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "Team",
    data() {
        return {
            today: new Date()
        }
    },
}
</script>

<style scoped>

</style>